import { SET_USER_PROFILE } from './types';

export function setUserProfile(userProfile = null) {
	return {
		type: SET_USER_PROFILE,
		payload: userProfile
	};
}
